const getSpacingCss = ( data, selector, type = 'padding' ) => {
	let style = '';
	const paddingUnit = '';
	style += `${ selector }{
		${ data?.desktop?.top ? `${ type }-top: ${ data.desktop.top }${ paddingUnit };` : '' }
		${ data?.desktop?.right ? `${ type }-right: ${ data.desktop.right }${ paddingUnit };` : '' }
		${ data?.desktop?.bottom ? `${ type }-bottom: ${ data.desktop.bottom }${ paddingUnit };` : '' }
		${ data?.desktop?.left ? `${ type }-left: ${ data.desktop.left }${ paddingUnit };` : '' }
	}`;

	// Wrapper media query for tablet.
	style += `@media only screen and (max-width: 992px) {
		${ selector }{

			${ data?.tablet?.top ? `${ type }-top: ${ data.tablet.top }${ paddingUnit };` : '' }
			${ data?.tablet?.right ? `${ type }-right: ${ data.tablet.right }${ paddingUnit };` : '' }
			${ data?.tablet?.bottom ? `${ type }-bottom: ${ data.tablet.bottom }${ paddingUnit };` : '' }
			${ data?.tablet?.left ? `${ type }-left: ${ data.tablet.left }${ paddingUnit };` : '' }
		}
	}`;

	// Wrapper media query for mobile.
	style += `@media only screen and (max-width: 768px) {
		${ selector }{

			${ data?.mobile?.top ? `${ type }-top: ${ data.mobile.top }${ paddingUnit };` : '' }
			${ data?.mobile?.right ? `${ type }-right: ${ data.mobile.right }${ paddingUnit };` : '' }
			${ data?.mobile?.bottom ? `${ type }-bottom: ${ data.mobile.bottom }${ paddingUnit };` : '' }
			${ data?.mobile?.left ? `${ type }-left: ${ data.mobile.left }${ paddingUnit };` : '' }
		}
	}`;

	return style;
};

export { getSpacingCss };
